/**
 * Client-safe enums and types.
 *
 * These were extracted VERBATIM from the (now removed) GraphQL codegen
 * output (src/generated/graphql.ts) so the client no longer depends on the
 * generated GraphQL module. Enum values are wire-compatible and must not be
 * changed. This module must stay client-safe: plain TypeScript only, NO
 * imports from @prisma/client, urql, or graphql.
 */

export enum AuditLogActionType {
  Created = 'Created',
  Deleted = 'Deleted',
  Read = 'Read',
  Updated = 'Updated',
}
export enum BillingCadence {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
}
export enum BusinessUnit {
  Benelux = 'Benelux',
  Forwarding = 'Forwarding',
  France = 'France',
  Germany = 'Germany',
}
export enum CarrierRole {
  CarrierDispatcher = 'CarrierDispatcher',
  CarrierDriver = 'CarrierDriver',
}
export enum Country {
  At = 'AT',
  Ba = 'BA',
  Be = 'BE',
  Bg = 'BG',
  Ch = 'CH',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dk = 'DK',
  Ee = 'EE',
  Es = 'ES',
  Fi = 'FI',
  Fr = 'FR',
  Gb = 'GB',
  Gr = 'GR',
  Hr = 'HR',
  Hu = 'HU',
  Ie = 'IE',
  It = 'IT',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Mk = 'MK',
  Mt = 'MT',
  Nl = 'NL',
  No = 'NO',
  Pl = 'PL',
  Pt = 'PT',
  Ro = 'RO',
  Rs = 'RS',
  Se = 'SE',
  Si = 'SI',
  Sk = 'SK',
}
export enum CreditNoteStatus {
  Created = 'Created',
  Draft = 'Draft',
  Sent = 'Sent',
}
export enum CustomerDocumentType {
  CustomerFile = 'CustomerFile',
  EInvoiceAgreement = 'EInvoiceAgreement',
  Other = 'Other',
  TransportInstructions = 'TransportInstructions',
}
export enum CustomerType {
  Direct = 'Direct',
  Transport = 'Transport',
}
export enum Day {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
}
export enum DocumentCategory {
  AnnexII = 'AnnexII',
  AnnexVII = 'AnnexVII',
  Cmr = 'Cmr',
  CreditNote = 'CreditNote',
  DeliveryNote = 'DeliveryNote',
  Invoice = 'Invoice',
  Other = 'Other',
  PalletNote = 'PalletNote',
  T1Document = 'T1Document',
  TransportOrder = 'TransportOrder',
  Unknown = 'Unknown',
  WeighSlip = 'WeighSlip',
}
export enum DocumentType {
  // NOTE: these values must match the strings persisted in the DocumentNote table.
  // The original server enum (Pothos) stored the PascalCase values below; under
  // GraphQL, Pothos translated the SCREAMING wire names back to these before the
  // resolver/DB used them. With GraphQL removed there is no translation layer, so
  // the enum VALUES must equal the persisted strings directly. (Codegen had
  // emitted SCREAMING values here, which would have orphaned existing rows.)
  PayReminderFourPrefix = 'PayReminderFourPrefix',
  PayReminderFourSuffix = 'PayReminderFourSuffix',
  PayReminderOnePrefix = 'PayReminderOnePrefix',
  PayReminderOneSuffix = 'PayReminderOneSuffix',
  PayReminderThreePrefix = 'PayReminderThreePrefix',
  PayReminderThreeSuffix = 'PayReminderThreeSuffix',
  PayReminderTwoPrefix = 'PayReminderTwoPrefix',
  PayReminderTwoSuffix = 'PayReminderTwoSuffix',
  Planning = 'PLANNING',
  Quotation = 'Quotation',
  Tro = 'TRO',
}
export enum EmailType {
  CarrierInvite = 'CARRIER_INVITE',
  CarrierPortalRequest = 'CARRIER_PORTAL_REQUEST',
  Cmr = 'CMR',
  CmrReminder = 'CMR_REMINDER',
  CmrReminderRegularCarriers = 'CMR_REMINDER_REGULAR_CARRIERS',
  CreditNote = 'CREDIT_NOTE',
  CustomerPortalRequest = 'CUSTOMER_PORTAL_REQUEST',
  DieselSurcharge = 'DIESEL_SURCHARGE',
  ForgotPassword = 'FORGOT_PASSWORD',
  Invoice = 'INVOICE',
  OrderCancelled = 'ORDER_CANCELLED',
  OrderConfirmation = 'ORDER_CONFIRMATION',
  PayReminderFour = 'PAY_REMINDER_FOUR',
  PayReminderOne = 'PAY_REMINDER_ONE',
  PayReminderThree = 'PAY_REMINDER_THREE',
  PayReminderTwo = 'PAY_REMINDER_TWO',
  Planning = 'PLANNING',
  Quotation = 'QUOTATION',
  RideOverview = 'RIDE_OVERVIEW',
  SelfBilling = 'SELF_BILLING',
  TransportOrder = 'TRANSPORT_ORDER',
  TransportOrderCancellation = 'TRANSPORT_ORDER_CANCELLATION',
  TransportOrderReminder = 'TRANSPORT_ORDER_REMINDER',
  TruckDocumentExpiration = 'TRUCK_DOCUMENT_EXPIRATION',
  UnreadNotifications = 'UNREAD_NOTIFICATIONS',
  UrgentCmrReminder = 'URGENT_CMR_REMINDER',
  UserInvite = 'USER_INVITE',
}
export enum IncassoStatus {
  Created = 'Created',
  Resolved = 'Resolved',
}
export enum IncomingDocumentRejectionReason {
  LowQuality = 'LowQuality',
  MissingSignature = 'MissingSignature',
  NoOrderReference = 'NoOrderReference',
  NotNeutral = 'NotNeutral',
  WrongCustomer = 'WrongCustomer',
  WrongDeliveryAddress = 'WrongDeliveryAddress',
  WrongDocumentType = 'WrongDocumentType',
  WrongOrgOnDocument = 'WrongOrgOnDocument',
}
export enum IncomingDocumentReviewReason {
  AmbiguousBoundary = 'AmbiguousBoundary',
  AmbiguousCustomer = 'AmbiguousCustomer',
  AmbiguousDeliveryAddress = 'AmbiguousDeliveryAddress',
  AmbiguousSignature = 'AmbiguousSignature',
  AmbiguousType = 'AmbiguousType',
  InvoicePolicy = 'InvoicePolicy',
  LowConfidence = 'LowConfidence',
  LowImageQuality = 'LowImageQuality',
  MultiDocSplitFailed = 'MultiDocSplitFailed',
  NoAiAnalysis = 'NoAiAnalysis',
  NoOrderMatch = 'NoOrderMatch',
  NonBusinessType = 'NonBusinessType',
  PartialPage = 'PartialPage',
  UnknownType = 'UnknownType',
}
export enum IncomingDocumentStatus {
  Approved = 'Approved',
  New = 'New',
  Pending = 'Pending',
  Rejected = 'Rejected',
}
export enum IncomingDocumentType {
  AnnexII = 'AnnexII',
  AnnexVII = 'AnnexVII',
  Cmr = 'CMR',
  DeliveryNote = 'DeliveryNote',
  Invoice = 'Invoice',
  Other = 'Other',
  PalletNote = 'PalletNote',
  T1Document = 'T1Document',
  TransportOrder = 'TransportOrder',
  WeighSlip = 'WeighSlip',
}
export enum InternalTrailerType {
  Mega = 'Mega',
  Tautliner = 'Tautliner',
}
export enum InvoiceDeliveryMethod {
  Email = 'EMAIL',
  Post = 'POST',
}
export enum InvoiceFrequency {
  Monthly = 'MONTHLY',
  Transport = 'TRANSPORT',
  Weekly = 'WEEKLY',
}
export enum InvoiceStatus {
  Created = 'Created',
  Draft = 'Draft',
  Paid = 'Paid',
  Sent = 'Sent',
}
export enum Language {
  De = 'DE',
  En = 'EN',
  Fr = 'FR',
  Lt = 'LT',
  Nl = 'NL',
  Pl = 'PL',
  Ro = 'RO',
  Tr = 'TR',
}
export enum LoadingMethod {
  Back = 'Back',
  Side = 'Side',
  Top = 'Top',
}
export enum LocationDocumentType {
  Other = 'Other',
}
export enum MailboxType {
  IncomingDocuments = 'IncomingDocuments',
  OrderEntry = 'OrderEntry',
}
export enum OrderComplaintType {
  Aggression = 'Aggression',
  DamagedGoods = 'DamagedGoods',
  IncorrectDelivery = 'IncorrectDelivery',
  IncorrectInvoice = 'IncorrectInvoice',
  LateDelivery = 'LateDelivery',
  Other = 'Other',
}
export enum OrderDateFilterType {
  Creation = 'Creation',
  Load = 'Load',
  Unload = 'Unload',
}
export enum OrderDocumentType {
  AnnexII = 'AnnexII',
  AnnexVII = 'AnnexVII',
  Cmr = 'CMR',
  CustomerAttachment = 'CustomerAttachment',
  DeliveryNote = 'DeliveryNote',
  OrderConfirmation = 'OrderConfirmation',
  Other = 'Other',
  PalletNote = 'PalletNote',
  Planning = 'Planning',
  SaleInvoice = 'SaleInvoice',
  SustainabilityReport = 'SustainabilityReport',
  T1Document = 'T1Document',
  TransportOrder = 'TransportOrder',
  WeighSlip = 'WeighSlip',
}
export enum OrderDocumentValidationStatus {
  Approved = 'Approved',
  NoDocuments = 'NoDocuments',
  Pending = 'Pending',
  Rejected = 'Rejected',
}
export enum OrderLineStopType {
  Load = 'Load',
  Unload = 'Unload',
}
export enum OrderOrigin {
  AiEntry = 'AiEntry',
  Api = 'Api',
  CustomerPortal = 'CustomerPortal',
  Manual = 'Manual',
  Transporeon = 'Transporeon',
}
export enum OrderOutstandingDocumentState {
  Missing = 'missing',
  Pending = 'pending',
  Rejected = 'rejected',
}
export enum OrderSelfBillReviewFlag {
  TotalDiverged = 'TotalDiverged',
  VatMismatch = 'VatMismatch',
}
export enum OrderStatus {
  Cancelled = 'Cancelled',
  Confirmed = 'Confirmed',
  Created = 'Created',
  Draft = 'Draft',
  Executed = 'Executed',
  Placed = 'Placed',
  Prepayment = 'Prepayment',
  Refused = 'Refused',
}
export enum PaymentReminderType {
  FirstReminder = 'FirstReminder',
  FourthReminder = 'FourthReminder',
  SecondReminder = 'SecondReminder',
  ThirdReminder = 'ThirdReminder',
}
export enum PaymentTerm {
  P14 = 'P14',
  P14E = 'P14E',
  P21 = 'P21',
  P21E = 'P21E',
  P30 = 'P30',
  P30E = 'P30E',
  P45 = 'P45',
  P60 = 'P60',
  P60E = 'P60E',
  P90 = 'P90',
  Pc7 = 'PC7',
}
export enum PurchaseStatus {
  Confirmed = 'Confirmed',
  Created = 'Created',
  Invoiced = 'Invoiced',
  SelfBillCreated = 'SelfBillCreated',
}
export enum QuotationType {
  Contract = 'Contract',
  Spot = 'Spot',
}
export enum SaleStatus {
  Created = 'Created',
  Credited = 'Credited',
  Incomplete = 'Incomplete',
  Invoiced = 'Invoiced',
}
export enum SelfBillKind {
  RideOverview = 'RideOverview',
  SelfBilling = 'SelfBilling',
}
export enum SelfBillingMode {
  None = 'None',
  RideOverview = 'RideOverview',
  SelfBilling = 'SelfBilling',
}
export enum SupplierDocumentType {
  CivilLiabilityInsurance = 'CivilLiabilityInsurance',
  CmrInsurance = 'CmrInsurance',
  Other = 'Other',
  Survey = 'Survey',
  TransportInsurance = 'TransportInsurance',
}
export enum SupplierDriverDocumentType {
  A1Document = 'A1Document',
  DriverAttestation = 'DriverAttestation',
  IMIDeclaration = 'IMIDeclaration',
  ProofOfLegalResidenceAndWorkPermit = 'ProofOfLegalResidenceAndWorkPermit',
}
export enum SupplierSelfBillStatus {
  Draft = 'Draft',
  Failed = 'Failed',
  Sent = 'Sent',
}
export enum SupplierTruckDocumentType {
  Examination = 'Examination',
  Insurance = 'Insurance',
}
export enum TrailerCostPayee {
  Customer = 'Customer',
  Internal = 'Internal',
  Supplier = 'Supplier',
}
export enum TrailerDocumentType {
  Coc = 'COC',
  Identification = 'Identification',
  Inspection = 'Inspection',
  Insurance = 'Insurance',
  Registration = 'Registration',
}
export enum TrailerType {
  BoxTrailer = 'BoxTrailer',
  FlatBed = 'FlatBed',
  Joloda = 'Joloda',
  Mega = 'Mega',
  Refrigerated = 'Refrigerated',
  RoadTrain = 'RoadTrain',
  Tautliner = 'Tautliner',
  TautlinerCoil = 'TautlinerCoil',
}

/**
 * Client-safe replacement for the GraphQL `Document` object type. Only the
 * fields consumed by client importers are included (matching the original
 * generated shape).
 */
export type Document = {
  createdAt: string;
  filename: string;
  hash: string;
  id: string;
  name: string;
};
